
import React from "react";
import { useNavigate } from "react-router-dom";
import { Trash } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useDeleteActivity } from "@/services/activityService";
import { toast } from "@/components/ui/sonner";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";

interface ActivityDeleteDialogProps {
  activityId: string;
}

export const ActivityDeleteDialog: React.FC<ActivityDeleteDialogProps> = ({ 
  activityId 
}) => {
  const navigate = useNavigate();
  const deleteActivity = useDeleteActivity();

  const handleDelete = async () => {
    try {
      await deleteActivity.mutateAsync(activityId);
      navigate('/activities');
    } catch (error) {
      toast.error("Erreur lors de la suppression de l'activité");
    }
  };

  return (
    <div className="flex justify-center">
      <AlertDialog>
        <AlertDialogTrigger asChild>
          <Button variant="destructive">
            <Trash className="h-4 w-4 mr-2" />
            Supprimer l'activité
          </Button>
        </AlertDialogTrigger>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Êtes-vous sûr?</AlertDialogTitle>
            <AlertDialogDescription>
              Cette action est irréversible. Cela supprimera définitivement cette activité planifiée.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Annuler</AlertDialogCancel>
            <AlertDialogAction onClick={handleDelete} className="bg-red-600 hover:bg-red-700">
              Supprimer
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};
